import Axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { api, storage, useRequest } from "../../utils";
var FormData = require("form-data");

const Exel = () => {
  const [exel, set_exel] = useState("");

  const sendData = () => {
    const formData = new FormData();
    formData.append("exel", exel);
    storage
      .load("token")
      .then((token) => {
        if (!token) {
          alert("لطفا دوباره وارد شوید");
          return;
        }
        return Axios.post(
          "https://dashboardapi.pipeup.ir/add_product_exel",
          formData,
          {
            headers: {
              "x-auth": token,
            },
          }
        );
      })
      .then((res) => {
        if (!res) return;
        alert("محصولات با موفقیت اضافه شدند");
      })
      .catch((err) => {
        alert("محصولات اضافه نشدند");
      });
  };

  const downloadExel = () => {
    storage
      .load("token")
      .then((token) => {
        if (!token) {
          alert("لطفا دوباره وارد شوید");
          return;
        }
        return Axios.get(
          "https://dashboardapi.pipeup.ir/download_products_exel",
          {
            headers: {
              "x-auth": token,
            },
            responseType: "blob",
          }
        );
      })
      .then((res) => {
        if (!res) return;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "products.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        alert("دانلود اکسل انجام نشد");
      });
  };

  return (
    <div style={{ marginBottom: "2rem" }}>
      <input type="file" onChange={(e) => set_exel(e.target.files[0])} />
      <button onClick={() => sendData()}>اپلود اکسل</button>

      <div
        style={{ color: "green", cursor: "pointer", marginTop: "2rem" }}
        onClick={downloadExel}
      >
        دانلود اکسل
      </div>
    </div>
  );
};

const GetProducts = (props) => {
  const [products_error, products_loading, products_data, products_function] =
    useRequest({
      method: "get",
      url: "/get_products",
    });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}

        <Exel />
        {products_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">عنوان</th>
                <th className="table--title">تخفیف</th>
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              products_data.data.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>{item.discount}</td>
                  <td>
                    <Link to={"/dashboard/editProduct/" + item._id}>
                      <button
                        type="button"
                        class="btn btn-primary round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetProducts };
